// =============================================================================
// Child theme entry — portal chrome shared by every page.
// The React apps (portal-shop / portal-checkout / portal-inventory) are
// separate entries enqueued by their blocks.
// =============================================================================

import { initSidebar } from "./portal/sidebar.js";
import { initCartCount } from "./portal/cart-count.js";
import { initCurrentLinks } from "./portal/current-links.js";
import { initSteppers } from "./portal/stepper.js";
import { initVariations } from "./portal/variations.js";

function boot() {
	initSidebar();
	initCartCount();
	initCurrentLinks();
	initSteppers();
	initVariations();
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
